import { render, staticRenderFns } from "./RolesAndPermissions.vue?vue&type=template&id=cd591524&scoped=true&"
import script from "./RolesAndPermissions.vue?vue&type=script&lang=js&"
export * from "./RolesAndPermissions.vue?vue&type=script&lang=js&"
import style0 from "./RolesAndPermissions.vue?vue&type=style&index=0&id=cd591524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd591524",
  null
  
)

export default component.exports